import styled from 'styled-components';
import { Checkbox } from 'ui/checkbox';
import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';

const StyledCheckboxGridCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

type NumOrString = number | string;
type Props<T extends NumOrString> = {
  /** function handler for click, passes the `id` value as the argument */
  handleClick: (id: T) => void;
  /** a unique id for the grid row item */
  id: T;
  /** what status the checkbox is in (checked/unchecked/indeterminate) */
  status: CHECKBOX_STATUS;
  /** whether the checkbox is disabled */
  isDisabled?: boolean;
};

export const CheckboxGridCell = <T extends NumOrString>({
  id,
  handleClick,
  status,
  isDisabled = false,
  ...props
}: Props<T>) => (
  <StyledCheckboxGridCell data-test="checkbox-grid-cell" {...props}>
    <Checkbox
      data-test="checkbox-grid-cell-checkbox"
      id={`checkbox-${id}`}
      onClick={() => handleClick(id)}
      status={status}
      isDisabled={isDisabled}
    />
  </StyledCheckboxGridCell>
);
